import { i18n } from '@shared/i18n';
import { filter } from 'lodash';

const tabsConfig = {
  inscriptions: {
    isDisabled: false,
    type: 'inscriptions',
    label: i18n('entities.inscription.label'),
    routerPush: {
      name: 'subpropertyPeople',
      params: {
        tabName: 'inscriptions',
        subtabName: 'all',
      },
    },
    buttonLink: null,
    buttonCode: '',
  },
  players: {
    isDisabled: process.env.VUE_APP_DISABLE_PLAYERS_TAB === 'true',
    type: 'players',
    label: i18n('entities.player.label'),
    routerPush: {
      name: 'subpropertyPeople',
      params: {
        tabName: 'players',
        subtabName: null,
      },
    },
    buttonLink: null,
    buttonCode: '',
  },
  families: {
    isDisabled: process.env.VUE_APP_DISABLE_FAMILY_TAB === 'true',
    type: 'families',
    label: i18n('entities.family.label'),
    routerPush: {
      params: {
        tabName: 'families',
        subtabName: null,
      },
    },
    buttonLink: null,
    buttonCode: '',
  },
  parents: {
    isDisabled: process.env.VUE_APP_DISABLE_PARENTS_TAB === 'true',
    type: 'parents',
    label: i18n('entities.parent.label'),
    routerPush: {
      params: {
        tabName: 'parents',
        subtabName: null,
      },
    },
    buttonLink: null,
    buttonCode: '',
  },
};

const subtabsConfig = {
  all: {
    isDisabled: false,
    type: 'all',
    label: i18n('enumerators.inscriptionStatus.all'),
    routerPush: {
      name: 'subpropertyPeople',
      params: {
        tabName: 'inscriptions',
        subtabName: 'all',
      },
    },
  },
  pendingApproval: {
    isDisabled: false,
    type: 'pendingApproval',
    label: i18n(
      'enumerators.inscriptionStatus.pendingApproval',
    ),
    routerPush: {
      name: 'subpropertyPeople',
      params: {
        tabName: 'inscriptions',
        subtabName: 'pendingApproval',
      },
    },
  },
  pendingPayment: {
    isDisabled: false,
    type: 'pendingPayment',
    label: i18n(
      'enumerators.inscriptionStatus.pendingPayment',
    ),
    routerPush: {
      name: 'subpropertyPeople',
      params: {
        tabName: 'inscriptions',
        subtabName: 'pendingPayment',
      },
    },
  },
  onTryout: {
    isDisabled: false,
    type: 'onTryout',
    label: i18n(
      'enumerators.inscriptionStatus.onTryout',
    ),
    routerPush: {
      name: 'subpropertyPeople',
      params: {
        tabName: 'inscriptions',
        subtabName: 'onTryout',
      },
    },
  },
  paid: {
    isDisabled: false,
    type: 'paid',
    label: i18n(
      'enumerators.inscriptionStatus.paid',
    ),
    routerPush: {
      name: 'subpropertyPeople',
      params: {
        tabName: 'inscriptions',
        subtabName: 'paid',
      },
    },
  },
  approved: {
    isDisabled: false,
    type: 'approved',
    label: i18n(
      'enumerators.inscriptionStatus.approved',
    ),
    routerPush: {
      name: 'subpropertyPeople',
      params: {
        tabName: 'inscriptions',
        subtabName: 'approved',
      },
    },
  },
  reject: {
    isDisabled: false,
    type: 'reject',
    label: i18n(
      'enumerators.inscriptionStatus.reject',
    ),
    routerPush: {
      name: 'subpropertyPeople',
      params: {
        tabName: 'inscriptions',
        subtabName: 'reject',
      },
    },
  },
};

export default {
  namespaced: true,

  state: {
    tabIndex: 0,
    subtabIndex: 0
  },

  getters: {
    tabs: (state, getters, rootState, rootGetters) => filter(tabsConfig, ({ type, isDisabled }) => {
      const isPropertyNBA = rootGetters['auth/manage/isPropertyNBA'];
      if (type === 'inscriptions' && isPropertyNBA) {
        return false;
      } else {
        return isDisabled === false;
      }
    }),
    subtabs: (state, getters, rootState, rootGetters) => filter(subtabsConfig, ({ isDisabled }) => {
      const isPropertyNBA = rootGetters['auth/manage/isPropertyNBA'];
      if (isPropertyNBA) {
        return false;
      } else {
        return isDisabled === false;
      }
    }),
    tabIndex: state => state.tabIndex,
    subtabIndex: state => state.subtabIndex,
  },

  mutations: {
    SET_TAB_INDEX(state, payload) {
      state.tabIndex = payload;
    },
    SET_SUBTAB_INDEX(state, payload) {
      state.subtabIndex = payload;
    }
  },

  actions: {
    doResetTabs({ commit } ) {
      commit('SET_TAB_INDEX', 0);
    },
    setTabIndex({ commit }, tabIndex ) {
      commit('SET_TAB_INDEX', tabIndex);
    },
    doResetSubtabs({ commit } ) {
      commit('SET_SUBTAB_INDEX', 0);
    },
    setSubtabIndex({ commit }, subtabIndex ) {
      commit('SET_SUBTAB_INDEX', subtabIndex);
    }
  },
};
